import React, { useState } from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const countryCodes = [
  { code: '+1', country: 'US/CA', flag: '🇺🇸' },
  { code: '+44', country: 'UK', flag: '🇬🇧' },
  { code: '+91', country: 'IN', flag: '🇮🇳' },
  { code: '+86', country: 'CN', flag: '🇨🇳' },
  { code: '+81', country: 'JP', flag: '🇯🇵' },
  { code: '+49', country: 'DE', flag: '🇩🇪' },
  { code: '+33', country: 'FR', flag: '🇫🇷' },
  { code: '+61', country: 'AU', flag: '🇦🇺' },
  { code: '+55', country: 'BR', flag: '🇧🇷' },
  { code: '+52', country: 'MX', flag: '🇲🇽' },
  { code: '+39', country: 'IT', flag: '🇮🇹' },
  { code: '+34', country: 'ES', flag: '🇪🇸' },
  { code: '+7', country: 'RU', flag: '🇷🇺' },
  { code: '+82', country: 'KR', flag: '🇰🇷' },
  { code: '+31', country: 'NL', flag: '🇳🇱' },
  { code: '+46', country: 'SE', flag: '🇸🇪' },
  { code: '+41', country: 'CH', flag: '🇨🇭' },
  { code: '+65', country: 'SG', flag: '🇸🇬' },
  { code: '+971', country: 'AE', flag: '🇦🇪' },
  { code: '+27', country: 'ZA', flag: '🇿🇦' },
  { code: '+92', country: 'PK', flag: '🇵🇰' },
  { code: '+880', country: 'BD', flag: '🇧🇩' },
  { code: '+234', country: 'NG', flag: '🇳🇬' },
  { code: '+20', country: 'EG', flag: '🇪🇬' },
  { code: '+90', country: 'TR', flag: '🇹🇷' },
];

const PhoneInput = ({ value, onChange, required, id, className, defaultCountryCode = '+1', onCountryChange, error }) => {
  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const [phoneNumber, setPhoneNumber] = useState('');

  // Update when defaultCountryCode changes
  React.useEffect(() => {
    setCountryCode(defaultCountryCode);
  }, [defaultCountryCode]);

  const handlePhoneChange = (e) => {
    let input = e.target.value;
    
    // Remove all non-digit characters
    const digitsOnly = input.replace(/\D/g, '');
    
    // Limit to 10 digits
    const limitedDigits = digitsOnly.slice(0, 10);
    
    // No formatting - keep as plain digits
    setPhoneNumber(limitedDigits);
    
    // Notify parent with only digits (no formatting)
    if (onChange) {
      onChange({ 
        target: { 
          name: 'phone', 
          value: limitedDigits // Only the digits, no formatting
        } 
      });
    }
    
    // Also notify about country code
    if (onCountryChange) {
      onCountryChange(countryCode.replace('+', ''));
    }
  };

  const handleCountryCodeChange = (code) => {
    setCountryCode(code);
    
    // Notify parent about country code change
    if (onCountryChange) {
      onCountryChange(code.replace('+', ''));
    }
    
    // Update phone value
    if (onChange) {
      onChange({ 
        target: { 
          name: 'phone', 
          value: phoneNumber // Only the phone number
        } 
      });
    }
  };

  return (
    <div>
      <Label htmlFor={id} className="text-gray-300">Contact Number *</Label>
      <div className="flex gap-2 mt-2">
        <Select value={countryCode} onValueChange={handleCountryCodeChange}>
          <SelectTrigger className="w-[140px] bg-slate-800 border-white/20 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-slate-800 border-white/20 text-white max-h-[300px]">
            {countryCodes.map((item) => (
              <SelectItem 
                key={item.code} 
                value={item.code}
                className="hover:bg-slate-700 focus:bg-slate-700"
              >
                <span className="flex items-center gap-2">
                  <span>{item.flag}</span>
                  <span>{item.code}</span>
                  <span className="text-gray-400 text-xs">({item.country})</span>
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          id={id}
          type="tel"
          value={phoneNumber}
          onChange={handlePhoneChange}
          required={required}
          className={`flex-1 ${className} ${error ? 'border-red-500' : ''}`}
          placeholder="5551234567"
          maxLength={10}
          pattern="[0-9]*"
        />
      </div>
    </div>
  );
};

export default PhoneInput;
